import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";


const RaiseFrameWorkPage = () => {
    const navigate = useNavigate();
    const image1 = require("../../assets/img/image 1.png");
    const image2 = require("../../assets/img/default community.jpg");

    const handleSupport = async () => {
        await navigate('customer/support')
    }

    const RaiseFrameWorkContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'RAISE_FRAME_WORK_CONTENT') : null;
    const RaiseFrameWorkDescription: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'RAISE_FRAME_WORK_DESCRIPTION_CONTENT') : null;



    return (
        <>
            <div className="min-h-screen bg-blue-50 text-gray-900 flex flex-col md:flex-row items-center justify-between px-8 py-20">
                {/* Left Section - Text */}
                <div className="md:w-1/2 mb-8 md:mb-0">
                    <h1 className="text-4xl font-bold mb-4 text-black">
                        {RaiseFrameWorkContent && RaiseFrameWorkContent[0]?.title ? (
                            (() => {
                                const titleWords = RaiseFrameWorkContent[0].title.split(' ');
                                const middle = Math.floor(titleWords.length / 2);
                                const firstHalf = titleWords.slice(0, middle).join(' ');
                                const secondHalf = titleWords.slice(middle).join(' ');
                                return (
                                    <>
                                        <span className="text-primary">{firstHalf} </span>
                                        <span className="text-black">{secondHalf}</span>
                                    </>
                                );
                            })()
                        ) : (
                            <>
                                <span className="text-orange-600">The RAISE </span>
                                <span className="text-black">Framework is designed to drive innovation</span>
                            </>
                        )}
                        {/* <span className="text-4xl font-bold mb-4 text-primary">
            The RAISE </span>
            Framework is designed to drive innovation */}
                    </h1>
                    <p className="text-lg mb-6">
                        {RaiseFrameWorkContent && RaiseFrameWorkContent[0]?.subTitle
                            ? RaiseFrameWorkContent[0].subTitle
                            : "Discover how the RAISE Framework empowers ecosystems by focusing on Resilience, Agility, Inclusion, Sustainability, and Empowerment."}
                        {/* Discover how the RAISE Framework empowers ecosystems by focusing on Resilience, Agility, Inclusion, Sustainability, and Empowerment.     */}
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <button className="bg-primary text-white px-6 py-3 rounded-md hover:bg-primary transition">
                            {RaiseFrameWorkContent && RaiseFrameWorkContent[0]?.description
                                ? RaiseFrameWorkContent[0].description
                                : "Request a demo"}
                            {/* Request a demo */}
                        </button>
                        <button className="border border-primary text-primary px-6 py-3 rounded-md hover:bg-blue-100 transition">
                            {RaiseFrameWorkContent && RaiseFrameWorkContent[1]?.description
                                ? RaiseFrameWorkContent[1].description
                                : "Calculate your potential ROI"}
                            {/* Calculate your potential ROI */}
                        </button>
                    </div>
                </div>

                {/* Right Section - Image */}
                <div className="md:w-1/2 flex justify-center">
                    <div className="relative">
                        {/* Background triangle style box */}
                        <div className="absolute top-0 left-0 w-full h-full bg-primary -z-10 transform rotate-12 origin-bottom-left scale-125 rounded-md"></div>
                        {/* Image */}
                        <img
                            src={RaiseFrameWorkContent && RaiseFrameWorkContent[0]?.src
                                ? RaiseFrameWorkContent[0].src
                                : image2}
                            alt="Worker with tablet"
                            className="relative z-10 w-full max-w-sm rounded-lg object-contain"
                        />
                    </div>
                </div>
            </div>

            <div className="min-h-screen bg-gray-50 text-gray-900 px-8 py-16">
                {/* Section Title */}
                <h2 className="text-3xl font-bold mb-6 text-center text-black">
                    {RaiseFrameWorkDescription && RaiseFrameWorkDescription[0]?.title ? (
                        (() => {
                            const titleWords = RaiseFrameWorkDescription[0].title.split(' ');
                            const middle = Math.floor(titleWords.length / 2);
                            const firstHalf = titleWords.slice(0, middle).join(' ');
                            const secondHalf = titleWords.slice(middle).join(' ');
                            return (
                                <>
                                    <span className="text-primary">{firstHalf} </span>
                                    <span className="text-black">{secondHalf}</span>
                                </>
                            );
                        })()
                    ) : (
                        <>
                            <span className="text-orange-600">The RAISE </span>
                            <span className="text-black">framework serves as a:</span>
                        </>
                    )}
                    {/* The RAISE
          <span className="text-3xl font-bold mb-6 text-center text-black"> framework serves as a:</span>  */}
                </h2>

                {/* Bullet Points */}
                <ul className="list-disc list-inside mb-12 text-lg text-gray-700 max-w-3xl mx-auto space-y-2">
                    <li>
                        {RaiseFrameWorkDescription && RaiseFrameWorkDescription[0]?.subTitle
                            ? RaiseFrameWorkDescription[0].subTitle
                            : "At the core of the RAISE Framework lies a commitment to creating sustainable and inclusive."}
                        {/* At the core of the RAISE Framework lies a commitment to creating sustainable and inclusive. */}
                    </li>
                    <li>
                        {RaiseFrameWorkDescription && RaiseFrameWorkDescription[1]?.subTitle
                            ? RaiseFrameWorkDescription[1].subTitle
                            : "inclusive growth through strategic interventions across key sectors of the digital economy."}
                        {/* inclusive growth through strategic interventions across key sectors of the digital economy. */}
                    </li>
                    <li>
                        {RaiseFrameWorkDescription && RaiseFrameWorkDescription[2]?.subTitle
                            ? RaiseFrameWorkDescription[2].subTitle
                            : "The RAISE Framework is designed to drive innovation, collaboration."}
                        {/* The RAISE Framework is designed to drive innovation, collaboration */}
                    </li>
                    <li>
                        {RaiseFrameWorkDescription && RaiseFrameWorkDescription[3]?.subTitle
                            ? RaiseFrameWorkDescription[3].subTitle
                            : "Comply with internal and external policies and regulations"}
                        {/* Comply with internal and external policies and regulations */}
                    </li>
                </ul>

                {/* Content Grid */}
                <div className="grid md:grid-cols-2 gap-10 items-start">

                    {/* Text Box Cards */}
                    <div className="space-y-6">
                        <div className="bg-white shadow-md p-6 rounded-lg border border-gray-200">
                            <h3 className="text-xl font-semibold mb-2 text-primary">
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[1]?.title
                                    ? RaiseFrameWorkDescription[1].title
                                    : "Gain visibility into your business processes"}
                                {/* Gain visibility into your business processes */}
                            </h3>
                            <p>
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[0]?.description
                                    ? RaiseFrameWorkDescription[0].description
                                    : "Build a stronger supply chain by responding more quickly to changing circumstances through tighter collaboration with your trading partners."}
                                {/* Build a stronger supply chain by responding more quickly to changing circumstances through tighter collaboration with your trading partners. */}
                            </p>
                        </div>

                        <div className="bg-white shadow-md p-6 rounded-lg border border-gray-200">
                            <h3 className="text-xl font-semibold mb-2 text-primary">
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[2]?.title
                                    ? RaiseFrameWorkDescription[2].title
                                    : "Operate more efficiently"}
                                {/* Operate more efficiently */}
                            </h3>
                            <p>
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[1]?.description
                                    ? RaiseFrameWorkDescription[1].description
                                    : "Close the break points between trading partners through digital transaction exchange and information sharing, leveraging business rules and AI."}
                                {/* Close the break points between trading partners through digital transaction exchange and information sharing, leveraging business rules and AI. */}
                            </p>
                        </div>

                        <div className="bg-white shadow-md p-6 rounded-lg border border-gray-200">
                            <h3 className="text-xl font-semibold mb-2 text-primary">
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[3]?.title
                                    ? RaiseFrameWorkDescription[3].title
                                    : "Drive compliance"}
                                {/* Drive compliance */}
                            </h3>
                            <p>
                                {RaiseFrameWorkDescription && RaiseFrameWorkDescription[2]?.description
                                    ? RaiseFrameWorkDescription[2].description
                                    : "Comply with internal and external policies and regulations through configurable business rules, support for product genealogy, and supplier profile data."}
                                {/* Comply with internal and external policies and regulations through configurable business rules, support for product genealogy, and supplier profile data. */}
                            </p>
                        </div>
                    </div>

                    {/* Video Box with Fallback */}
                    <div className="flex justify-center items-center">
                        <div className="w-full max-w-md rounded-lg shadow-md border border-gray-300 overflow-hidden">
                            <video
                                controls
                                autoPlay
                                muted
                                playsInline
                                className="w-full h-auto bg-black rounded-md shadow-md"
                            >
                                <source
                                    src={
                                        RaiseFrameWorkDescription && RaiseFrameWorkDescription[0]?.src
                                            ? RaiseFrameWorkDescription[0].src
                                            : "https://cdn.coverr.co/videos/coverr-working-together-5584/1080p.mp4"
                                    }
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>

                            <div
                                id="video-fallback"
                                style={{ display: "none" }}
                                className="p-8 text-center text-red-600 font-semibold"
                            >
                                No video available
                            </div>
                        </div>
                    </div>
                </div>


            </div>



        </>
    );
};

export default RaiseFrameWorkPage;
